import React, { Component } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import BaseNav from 'react-bootstrap/Nav'
import Button from 'react-bootstrap/Button'
import Link from './Link'
import { extend } from '../../../utils/classes'

export class Nav extends Component {
  links = ['feature', 'how', 'pricing']

  baseClass = 'nav'

  renderLinks = () =>
    this.links.map((id, index) => (
      <Link href={`#${id}`} key={index} parentClass={this.baseClass}>
        {id}
      </Link>
    ))

  getNav() {
    return document.querySelector(`.${this.baseClass}`)
  }

  setBackground = (value) => {
    const nav = this.getNav()
    nav.style.backgroundColor = value
  }

  setBackgroundFilled = () => this.setBackground('#504c89')

  setBackgroundTransparent = () => this.setBackground('transparent')

  getTopDistance = (element) =>
    element.getBoundingClientRect().top + window.scrollY

  getIfNavIsAfterHeader = () => {
    const nav = this.getNav()
    const header = document.querySelector('.header')
    return this.getTopDistance(nav) > this.getTopDistance(header)
  }

  handleScroll = () => {
    const navIsAfterHeader = this.getIfNavIsAfterHeader()
    if (navIsAfterHeader) {
      return this.setBackgroundFilled()
    }
    return this.setBackgroundTransparent()
  }

  watchNav = () => {
    document.addEventListener('scroll', this.handleScroll)
  }

  componentDidMount() {
    this.watchNav()
  }

  handleToggle = (isExpanded) => {
    if (isExpanded) {
      this.setBackgroundFilled()
    }
  }

  render() {
    const navId = 'nav'
    return (
      <Navbar
        className={this.baseClass}
        expand="lg"
        onToggle={this.handleToggle}
      >
        <div className="container">
          <Navbar.Brand href="#">Brand</Navbar.Brand>
          <Navbar.Toggle aria-controls={navId}></Navbar.Toggle>
          <Navbar.Collapse id={navId}>
            <BaseNav className="ml-auto">
              <Link href="#" parentClass={this.baseClass}>
                Home
              </Link>
              {this.renderLinks()}
              <Button
                variant="outline-light"
                className={extend(this.baseClass, 'action')}
              >
                Get Started
              </Button>
            </BaseNav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    )
  }
}

export default Nav
